module.exports = __webpack_public_path__ + "img/iconfont.836bc9a0.svg";